(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initLightbox();
    initReviewModal();
    initVariants();
    initProductAccordion();
  });

  function initGallery() {
    var slides = document.querySelectorAll('.dm-gallery__slide');
    var thumbs = document.querySelectorAll('.dm-gallery__thumb');
    var prevBtn = document.querySelector('.dm-gallery__nav--prev');
    var nextBtn = document.querySelector('.dm-gallery__nav--next');

    if (!slides.length) return;

    var currentIndex = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === currentIndex);
      });

      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === currentIndex);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.dataset.index, 10) || 0);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    }

    slides.forEach(function (slide, index) {
      var img = slide.querySelector('img');
      if (img) {
        img.addEventListener('click', function () {
          if (typeof window.openLightbox === 'function') {
            window.openLightbox(index);
          }
        });
      }
    });

    window.dmGalleryGoTo = goTo;
    window.dmGalleryCurrentIndex = function () {
      return currentIndex;
    };
  }

  function initLightbox() {
    var slides = document.querySelectorAll('.dm-gallery__slide img');
    var lightbox = document.querySelector('.dm-lightbox');
    var lightboxImg = document.querySelector('.dm-lightbox-img');
    var nextBtn = document.querySelector('.dm-lightbox-next');
    var prevBtn = document.querySelector('.dm-lightbox-prev');
    var dotsWrap = document.querySelector('.dm-lightbox-dots');

    if (!lightbox || !slides.length) return;

    var currentIndex = 0;

    slides.forEach(function (_, i) {
      var dot = document.createElement('span');
      dot.addEventListener('click', function () {
        currentIndex = i;
        openLightbox(i);
      });
      if (dotsWrap) dotsWrap.appendChild(dot);
    });

    window.openLightbox = function (index) {
      currentIndex = typeof index === 'number' ? index : window.dmGalleryCurrentIndex ? window.dmGalleryCurrentIndex() : 0;
      var img = slides[currentIndex];
      if (!img) return;

      lightbox.style.display = 'flex';
      lightboxImg.src = img.dataset.full || img.src;
      updateDots();
    };

    function updateDots() {
      if (!dotsWrap) return;
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
        dot.classList.toggle('active', i === currentIndex);
      });
    }

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) lightbox.style.display = 'none';
    });

    if (nextBtn) {
      nextBtn.onclick = function () {
        currentIndex = (currentIndex + 1) % slides.length;
        openLightbox(currentIndex);
      };
    }

    if (prevBtn) {
      prevBtn.onclick = function () {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        openLightbox(currentIndex);
      };
    }
  }

  function initReviewModal() {
    var reviewBtn = document.querySelector('.dm-write-review');
    var reviewModal = document.getElementById('reviewModal');
    var closeReview = document.getElementById('closeReviewModal');
    var form = document.getElementById('reviewForm');
    var nextInput = document.getElementById('reviewNext');
    var continueBtn = document.getElementById('continueShopping');
    var params = new URLSearchParams(window.location.search);

    if (reviewBtn && reviewModal) {
      reviewBtn.addEventListener('click', function () {
        reviewModal.style.display = 'flex';
      });
    }

    if (closeReview && reviewModal) {
      closeReview.addEventListener('click', function () {
        reviewModal.style.display = 'none';
      });
    }

    if (reviewModal) {
      reviewModal.addEventListener('click', function (e) {
        if (e.target === reviewModal) reviewModal.style.display = 'none';
      });
    }

    if (form && nextInput) {
      nextInput.value = window.location.href.split('?')[0] + '?review=success';
    }

    if (params.get('review') === 'success' && reviewModal && form) {
      var success = document.querySelector('.dm-review-success');
      reviewModal.style.display = 'flex';
      form.style.display = 'none';
      if (success) success.style.display = 'block';
      history.replaceState({}, document.title, window.location.pathname);
    }

    if (continueBtn && reviewModal) {
      continueBtn.addEventListener('click', function () {
        reviewModal.style.display = 'none';
      });
    }
  }

  function initVariants() {
    var jsonEl = document.getElementById('dm-product-variants-json');
    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent || '[]');
    } catch (e) {
      return;
    }

    var pills = document.querySelectorAll('.dm-variant-pill');
    var priceWrap = document.querySelector('.dm-price-wrap');
    var skuEl = document.querySelector('.dm-sku');
    var atcBtns = document.querySelectorAll('.add-to-cart');

    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    function applyVariant(variant) {
      if (!variant) return;

      if (skuEl) skuEl.textContent = 'SKU: ' + (variant.sku || '—');

      atcBtns.forEach(function (btn) {
        btn.dataset.variantId = variant.id;
      });

      if (priceWrap) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWrap.innerHTML =
            '<span class="dm-price-sale">' +
            formatMoney(variant.price) +
            '</span><span class="dm-price-compare">' +
            formatMoney(variant.compare_at_price) +
            '</span>';
        } else {
          priceWrap.innerHTML = '<span class="dm-price-regular">' + formatMoney(variant.price) + '</span>';
        }
      }

      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('active');
        });
        pill.classList.add('active');
        var variant = variants.find(function (v) {
          return v.option1 === pill.dataset.value;
        });
        applyVariant(variant);
      });
    });

    var urlParams = new URLSearchParams(window.location.search);
    var variantIdFromUrl = urlParams.get('variant');
    var initialVariant = null;

    if (variantIdFromUrl) {
      initialVariant = variants.find(function (v) {
        return String(v.id) === String(variantIdFromUrl);
      });
    }

    if (!initialVariant) {
      initialVariant = variants.find(function (v) {
        return v.available;
      }) || variants[0];
    }
  }

  function initProductAccordion() {
    var accordion = document.querySelector('.dm-accordion--product');
    if (!accordion) return;

    var detailsList = Array.prototype.slice.call(accordion.querySelectorAll('details'));
    var guidesDetails = detailsList.find(function (details) {
      var summary = details.querySelector('summary');
      return summary && summary.textContent.trim() === 'Guides & Resources';
    });

    if (!guidesDetails) return;

    var shippingDetails = detailsList.find(function (details) {
      var summary = details.querySelector('summary');
      return summary && summary.textContent.trim() === 'Shipping Information';
    });

    var returnsDetails = detailsList.find(function (details) {
      var summary = details.querySelector('summary');
      return summary && summary.textContent.trim() === 'Returns Policy';
    });

    [shippingDetails, returnsDetails].forEach(function (details) {
      if (details && guidesDetails.contains(details)) {
        accordion.appendChild(details);
      }
    });

    var resources = guidesDetails.querySelector('.dm-resources');
    if (resources) {
      Array.prototype.slice
        .call(resources.querySelectorAll('a[href*="returns"], .dm-resource-card.disabled'))
        .forEach(function (node) {
          node.remove();
        });
    }
  }
})();
